/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";
import axios from "../../CustomAxios";

import {
  Avatar,
  Button,
  Paper,
  TextField,
  Typography,
  Box,
  Alert,
} from "@mui/material";

import ResetPasswordComponent from "../../components/auth/ResetPassword";
import { useNavigate, useSearchParams } from "react-router-dom";

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};
  width: 400px;

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;
const BigAvatar = styled(Avatar)`
  width: 92px;
  height: 92px;
  text-align: center;
  margin: 0 auto ${(props) => props.theme.spacing(5)};
`;

function ResetPassword() {
  const navigate = useNavigate();
  const [searchParam, setSearchParam] = useSearchParams();
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const userType = searchParam.get("user");
  const [mailSubmitted, setMailSubmitted] = useState(false);
  const [otp, setOtp] = useState("");
  const [err, setErr] = React.useState("");
  const [loading, setLoading] = useState(false);

  const sendOTP = async () => {
    try {
      setLoading(true);
      const config = {
        headers: {
          "x-auth-token": token,
        },
      };
      const { data } = await axios.post(
        `/api/v1/${userType}/reset_password/verify`,
        {
          email_address: email,
          otp_code: otp,
        },
        config
      );
      if (data.success) {
        localStorage.setItem("reset_token", data.reset_token);
        setLoading(false);
        navigate(`/reset-password/update?user=${userType}`);
      }
    } catch (e) {
      console.log(e);
      if (e.response.data.error) {
        setErr(e.response.data.error);
      } else {
        setErr("Server Error");
      }
    }
  };

  return (
    <React.Fragment>
      <Helmet title="Alpha Plus" />

      <Wrapper>
        {err ? (
          <Alert mt={2} mb={3} severity="error">
            {err}
          </Alert>
        ) : null}
        <BigAvatar alt="Lucy" src="/static/img/avatars/icon.png" />

        <Typography component="h1" variant="h4" align="center" gutterBottom>
          {mailSubmitted ? "Enter OTP" : "Reset Password"}
        </Typography>
        <Typography component="h2" variant="body1" align="center">
          {mailSubmitted
            ? "You must have received an OTP on your email. Please enter that OTP to update your password"
            : "Enter your email to reset your password"}
        </Typography>

        {mailSubmitted ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <TextField
              placeholder="Enter OTP"
              sx={{ marginTop: 4 }}
              fullWidth
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
            <Button
              variant="contained"
              color="primary"
              sx={{ marginTop: 4 }}
              fullWidth
              disabled={otp.length !== 6 || loading}
              onClick={sendOTP}
            >
              {loading ? "Submitting OTP..." : " Submit OTP"}
            </Button>
          </Box>
        ) : (
          <ResetPasswordComponent
            setMailSubmitted={setMailSubmitted}
            userType={userType}
            setEmail={setEmail}
            setToken={setToken}
            loading={loading}
            setLoading={setLoading}
          />
        )}
      </Wrapper>
    </React.Fragment>
  );
}

export default ResetPassword;
